<div *ngIf="video?.host_identifier" class="embed-responsive embed-responsive-16by9 {{classes}}">
    <iframe [src]="iframeSrc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
</div>